var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"call wow fadeIn",attrs:{"data-wow-delay":"50ms"}},[_c('div',[_vm._v("\n    专业咨询顾问，为您提供1对1专属服务\n  ")]),_c('router-link',{attrs:{"to":"/consultate"}},[_vm._v("立即咨询")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }